<app-print-layout [printId]="payload().printId"
  [summaryItems]="printSummaryItems()"
  [visible]="true">
  @for (ticket of printableTickets(); track ticket.guid) {
    <app-print-layout-section>
      <div class="a4-pdf-card__header">
        <div class="a4-pdf-card__title-group">
          <h4 class="a4-pdf-card__title">{{ ticket.name }}</h4>
          <span class="a4-pdf-card__kicker">ID {{ ticket.guid }}</span>
        </div>
        <div class="a4-pdf-card__status">
          <span class="a4-pdf-card__status-pill"
            [ngClass]="getStatusClass(ticket)">
            {{ 'kanban.status.' + ticket.status | translate }}
          </span>
        </div>
      </div>

      <div class="a4-pdf-card__facts">
        @if (ticket.roomLabel) {
          <div class="a4-pdf-card__fact">
            <span class="a4-pdf-card__fact-label">{{ payload().labels.room }}</span>
            <span class="a4-pdf-card__fact-value">{{ ticket.roomLabel }}</span>
          </div>
        }
        @if (getTicketAssigneeLabel(ticket); as assignee) {
          <div class="a4-pdf-card__fact">
            <span class="a4-pdf-card__fact-label">{{ payload().labels.assignees }}</span>
            <span class="a4-pdf-card__fact-value">{{ assignee }}</span>
          </div>
        }
        @if (getDeadlineOnly(ticket); as deadline) {
          <div class="a4-pdf-card__fact">
            <span class="a4-pdf-card__fact-label">{{ payload().labels.deadline }}</span>
            <span class="a4-pdf-card__fact-value">{{ deadline | date:'d.M.yyyy' }}</span>
          </div>
        }
      </div>

      <div class="a4-pdf-card__body">
        <div class="a4-pdf-card__content">
          <p class="a4-pdf-card__description">{{ ticket.description || '-' }}</p>
        </div>
        <div class="a4-pdf-card__history">
          @for (history of ticket.history ?? []; track $index; let i = $index) {
            @if (i < historyLimit()) {
              <div class="a4-pdf-history-row">
                <span class="a4-pdf-card__history-event">{{ formatHistoryTimestamp(history.timestamp) }}
                  {{ 'kanban.logEvent.' + history.status | translate:{ additionalWork: ticket.blockedBy ? ('kanban.logEvent.additionalWork' | translate) : '' } }}
                </span>
                <span class="a4-pdf-card__history-user">{{ history.username }}</span>
              </div>
            }
          }
        </div>
      </div>

      @if (includeImages()) {
        @if (ticket.images?.length > 0 || ticket.videos?.length > 0) {
          <div class="a4-pdf-card__images">
            <div class="images">
              @for (image of ticket.images; track $index) {
                <img [src]="image" />
              }
              @for (video of ticket.videos; track $index) {
                <img [src]="video" />
              }
            </div>
          </div>
        }
      }
    </app-print-layout-section>
  }
</app-print-layout>